import { createSlice } from "@reduxjs/toolkit";
import { getdisputeLogFileByNameThunk, getdisputeLogFilesThunk, getLogFileByNameThunk, getLogFilesThunk, uploadCustomerBulk, uploadDisputeBulk } from "../thunks/BulkUploadThunk";

const initialState = {
  // File upload related state
  selectedFile: null,
  uploadProgress: 0,
  uploadStatus: "",
  uploadResults: null,
  isLoading: false,
  isDragging: false,
  error: null,
  setError: null,
  setUploadResults: null,
  // Log files related state
  logFiles: null,
  selectedLogFile: null,
  logFilesLoading: false,
  logFilesError: null,
};

const customerBulkUploadSlice = createSlice({
  name: "customerBulkUpload",
  initialState,
  reducers: {
    setSelectedFile: (state, action) => {
      state.selectedFile = action.payload;
      state.error = null;
      state.uploadStatus = "";
    },
    setUploadProgress: (state, action) => {
      state.uploadProgress = action.payload;
    },
    setUploadStatus: (state, action) => {
      state.uploadStatus = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setIsDragging: (state, action) => {
      state.isDragging = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setUploadResults: (state, action) => {
      state.uploadResults = action.payload;
    },
    resetUploadState: (state) => {
      state.selectedFile = null;
      state.uploadProgress = 0;
      state.uploadStatus = "";
      state.uploadResults = null;
      state.isLoading = false;
      state.isDragging = false;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearUploadStatus: (state) => {
      state.uploadStatus = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Upload Customer Bulk cases
      .addCase(uploadCustomerBulk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.uploadProgress = 0;
        state.uploadStatus = "Uploading...";
      })
      .addCase(uploadCustomerBulk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.uploadProgress = 100;
        state.uploadStatus = "Upload completed successfully!";
        state.uploadResults = action.payload;
        // Refresh log files after successful upload
      })
      .addCase(uploadCustomerBulk.rejected, (state, action) => {
        state.isLoading = false;
        state.uploadProgress = 0;
        state.uploadStatus = "";
        state.error = action.payload || "Upload failed. Please try again.";
      })

      // Get Log Files cases
      .addCase(getLogFilesThunk.pending, (state) => {
        state.logFilesLoading = true;
        state.logFilesError = null;
      })
      .addCase(getLogFilesThunk.fulfilled, (state, action) => {
        state.logFilesLoading = false;
        state.logFiles = action.payload;
      })
      .addCase(getLogFilesThunk.rejected, (state, action) => {
        state.logFilesLoading = false;
        state.logFilesError = action.payload;
      })

      // Get Log File By Name cases
      .addCase(getLogFileByNameThunk.pending, (state) => {
        state.logFilesLoading = true;
        state.logFilesError = null;
      })
      .addCase(getLogFileByNameThunk.fulfilled, (state, action) => {
        state.logFilesLoading = false;
        state.selectedLogFile = action.payload;
      })
      .addCase(getLogFileByNameThunk.rejected, (state, action) => {
        state.logFilesLoading = false;
        state.logFilesError = action.payload;
      })

// dispute
  // Upload Customer Bulk cases
      .addCase(uploadDisputeBulk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.uploadProgress = 0;
        state.uploadStatus = "Uploading...";
      })
      .addCase(uploadDisputeBulk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.uploadProgress = 100;
        state.uploadStatus = "Upload completed successfully!";
        state.uploadResults = action.payload;
        // Refresh log files after successful upload
      })
      .addCase(uploadDisputeBulk.rejected, (state, action) => {
        state.isLoading = false;
        state.uploadProgress = 0;
        state.uploadStatus = "";
        state.error = action.payload || "Upload failed. Please try again.";
      })
 // Get Log Files cases
      .addCase(getdisputeLogFilesThunk.pending, (state) => {
        state.logFilesLoading = true;
        state.logFilesError = null;
      })
      .addCase(getdisputeLogFilesThunk.fulfilled, (state, action) => {
        state.logFilesLoading = false;
        state.logFiles = action.payload;
      })
      .addCase(getdisputeLogFilesThunk.rejected, (state, action) => {
        state.logFilesLoading = false;
        state.logFilesError = action.payload;
      })

 // Get Log File By Name cases
      .addCase(getdisputeLogFileByNameThunk.pending, (state) => {
        state.logFilesLoading = true;
        state.logFilesError = null;
      })
      .addCase(getdisputeLogFileByNameThunk.fulfilled, (state, action) => {
        state.logFilesLoading = false;
        state.selectedLogFile = action.payload;
      })
      .addCase(getdisputeLogFileByNameThunk.rejected, (state, action) => {
        state.logFilesLoading = false;
        state.logFilesError = action.payload;
      })

  },
});

export const {
  setError,
  setUploadResults,
  setSelectedFile,
  setUploadProgress,
  setUploadStatus,
  setLoading,
  setIsDragging,
  resetUploadState,
  clearError,
  clearUploadStatus,
} = customerBulkUploadSlice.actions;

export default customerBulkUploadSlice.reducer;
